/**
 * sale-notification.js | Next Vault Theme
 *
 * Fake-but-realistic purchase notification popup.
 * Zero external dependencies. Lightweight (~3 KB min).
 */
(function () {
  'use strict';

  /* ── Data ──────────────────────────────────────────────────────────────── */

  var NAMES = [
    'Sarah M.', 'James R.', 'Emily K.', 'Daniel T.', 'Olivia S.',
    'Michael B.', 'Jessica L.', 'Chris W.', 'Ashley N.', 'Ryan P.',
    'Amanda C.', 'Brandon H.', 'Megan J.', 'Tyler F.', 'Lauren G.',
    'Kevin D.', 'Stephanie V.', 'Justin E.', 'Kayla O.', 'Nathan Z.',
    'Rachel A.', 'Josh M.', 'Brittany H.', 'Andrew K.', 'Samantha R.',
    'Jonathan L.', 'Heather C.', 'David N.', 'Christina B.', 'Eric W.',
    'Nicole F.', 'Matthew T.', 'Amber S.', 'Adam J.', 'Melissa G.'
  ];

  var LOCATIONS = [
    'Austin, TX', 'Denver, CO', 'Nashville, TN', 'Portland, OR',
    'Charlotte, NC', 'Phoenix, AZ', 'Seattle, WA', 'Atlanta, GA',
    'Chicago, IL', 'Houston, TX', 'San Diego, CA', 'Miami, FL',
    'Dallas, TX', 'Boston, MA', 'Las Vegas, NV', 'Minneapolis, MN',
    'Orlando, FL', 'San Antonio, TX', 'Columbus, OH', 'Raleigh, NC',
    'Salt Lake City, UT', 'Indianapolis, IN', 'Kansas City, MO',
    'Pittsburgh, PA', 'Richmond, VA', 'Memphis, TN', 'Louisville, KY',
    'Oklahoma City, OK', 'Tucson, AZ', 'Albuquerque, NM'
  ];

  var TIMES = [
    '3 minutes ago',
    '5 minutes ago',
    '8 minutes ago',
    '12 minutes ago',
    '18 minutes ago',
    '24 minutes ago',
    '30 minutes ago',
    '45 minutes ago',
    '1 hour ago',
    '2 hours ago'
  ];

  /* Pravatar.cc — free CDN of 70 realistic human face photos (no auth needed) */
  var AVATAR_COUNT = 70;

  /* ── Helpers ────────────────────────────────────────────────────────────── */

  function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function randInt(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

  function getProductImage() {
    /* Try the main product image on a product page */
    var mainImg = document.getElementById('st-main-img');
    if (mainImg && mainImg.src && !mainImg.src.includes('no-image')) {
      return mainImg.src;
    }
    /* Fallback: first visible product card image */
    var cardImg = document.querySelector('.st-product-card img, .rp-card-img');
    if (cardImg && cardImg.src) return cardImg.src;
    return '';
  }

  /* ── Core ───────────────────────────────────────────────────────────────── */

  function SaleNotification() {
    this.popup    = document.getElementById('sn-popup');
    if (!this.popup) return;

    this.nameEl   = document.getElementById('sn-name');
    this.locEl    = document.getElementById('sn-location');
    this.timeEl   = document.getElementById('sn-time');
    this.avatarEl = document.getElementById('sn-avatar');
    this.imgEl    = document.getElementById('sn-product-img');
    this.closeBtn = document.getElementById('sn-close');
    this.actionEl = document.getElementById('sn-action');

    /* Read config from data attrs (set by Liquid section settings) */
    this.displayDelay  = parseInt(this.popup.dataset.displayDelay  || '5',  10) * 1000;
    this.hideDelay     = parseInt(this.popup.dataset.hideDelay     || '6',  10) * 1000;
    this.interval      = parseInt(this.popup.dataset.interval      || '18', 10) * 1000;
    this.position      = this.popup.dataset.position || 'bottom-left';

    this.hideTimer     = null;
    this.nextTimer     = null;
    this.progressEl    = null;
    this.usedIndices   = [];   /* prevent repeating the same name twice in a row */

    this._applyPosition();
    this._buildProgress();
    this._bindClose();
  }

  SaleNotification.prototype._applyPosition = function () {
    if (this.position === 'bottom-right') {
      this.popup.classList.add('sn-pos-right');
    }
  };

  SaleNotification.prototype._buildProgress = function () {
    var bar = document.createElement('div');
    bar.className = 'sn-progress';
    this.popup.querySelector('.sn-inner').appendChild(bar);
    this.progressEl = bar;
  };

  SaleNotification.prototype._bindClose = function () {
    var self = this;
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function () {
        self.hide();
        /* Restart the cycle after the interval */
        clearTimeout(self.nextTimer);
        self.nextTimer = setTimeout(function () { self.show(); }, self.interval);
      });
    }
  };

  /* Pick a random entry that wasn't the last one shown */
  SaleNotification.prototype._pickRandNoRepeat = function (arr) {
    if (arr.length <= 1) return 0;
    var last = this.usedIndices[this.usedIndices.length - 1];
    var idx;
    do { idx = randInt(0, arr.length - 1); } while (idx === last);
    this.usedIndices.push(idx);
    if (this.usedIndices.length > 4) this.usedIndices.shift();
    return idx;
  };

  SaleNotification.prototype.populate = function () {
    var nameIdx = this._pickRandNoRepeat(NAMES);
    var name     = NAMES[nameIdx];
    var location = rand(LOCATIONS);
    var time     = rand(TIMES);
    var avatarN  = randInt(1, AVATAR_COUNT);

    /* Update text */
    if (this.nameEl)   this.nameEl.textContent   = name;
    if (this.locEl)    this.locEl.textContent     = ' from ' + location;
    if (this.timeEl)   this.timeEl.textContent    = time;
    if (this.actionEl) this.actionEl.textContent  = 'just purchased this product';

    /* Avatar */
    if (this.avatarEl) {
      this.avatarEl.src = 'https://i.pravatar.cc/60?img=' + avatarN;
      this.avatarEl.alt = name;
    }

    /* Product image */
    if (this.imgEl) {
      var src = getProductImage();
      if (src) {
        this.imgEl.src     = src;
        this.imgEl.style.display = 'block';
        this.imgEl.classList.remove('is-loaded');
        this.imgEl.onload  = function () { this.classList.add('is-loaded'); };
        this.imgEl.onerror = function () { this.style.display = 'none'; };
      } else {
        this.imgEl.style.display = 'none';
      }
    }
  };

  SaleNotification.prototype.show = function () {
    this.populate();
    this.popup.setAttribute('aria-hidden', 'false');
    this.popup.classList.add('is-visible');

    /* Animate progress bar */
    if (this.progressEl) {
      this.progressEl.style.transition = 'none';
      this.progressEl.style.transform  = 'scaleX(1)';
      /* Force reflow */
      void this.progressEl.offsetWidth;
      this.progressEl.style.transition = 'transform ' + (this.hideDelay / 1000) + 's linear';
      this.progressEl.style.transform  = 'scaleX(0)';
    }

    /* Auto-hide */
    var self = this;
    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(function () {
      self.hide();
      /* Schedule next */
      self.nextTimer = setTimeout(function () { self.show(); }, self.interval);
    }, this.hideDelay);
  };

  SaleNotification.prototype.hide = function () {
    this.popup.classList.remove('is-visible');
    this.popup.setAttribute('aria-hidden', 'true');
    clearTimeout(this.hideTimer);
  };

  SaleNotification.prototype.start = function () {
    var self = this;
    /* Stagger first appearance by displayDelay */
    this.nextTimer = setTimeout(function () {
      self.show();
    }, this.displayDelay);
  };

  /* ── Public init ────────────────────────────────────────────────────────── */

  window.snInit = function () {
    /* Only run on product pages — check body class injected by theme.liquid */
    if (!document.body.classList.contains('template-product')) return;
    var sn = new SaleNotification();
    if (sn.popup) sn.start();
  };

  /* Also attempt init immediately in case DOMContentLoaded already fired */
  if (document.readyState !== 'loading') {
    window.snInit();
  }

})();
